import { Module } from 'vuex';

import actions from './actions';
import mutations from './mutations';

export const state: Store.Player.State = {};

const namespaced = true;

export const player: Module<Store.Player.State, RootState> = {
  namespaced,
  state,
  mutations,
  actions,
};
